import { useTracking } from 'react-tracking';
import type { RouterLinkAction } from '@redux-first-router-link';
import { RouterLink } from '@redux-first-router-link';
import type { ReactNode } from 'react';
import { cn } from '@simplywallst/ui-core/next';

type Props = {
  to: RouterLinkAction | undefined;
  title: ReactNode;
  isLast: boolean;
  index: number;
};

export const BreadcrumbListItem = ({ to, title, isLast, index }: Props) => {
  const { Track, trackEvent } = useTracking();

  return (
    <Track>
      <li className={cn('truncate', index === 0 && 'max-w-[75%]')}>
        {to ? (
          <RouterLink
            data-cy-id={`child-link-${index}`}
            to={to}
            className="text-xs hover:text-soft focus-visible:ring"
            inheritColor
            onClick={() =>
              trackEvent({
                action: 'click',
                modifier: 'crumb',
                index: index,
                label: title,
              })
            }
          >
            {title}
          </RouterLink>
        ) : (
          <span data-cy-id={`child-link-${index}`} className="text-xs">
            {title}
          </span>
        )}
      </li>
      {!isLast && <li>/</li>}
    </Track>
  );
};
